package com.yogaaicoach.pages.contact

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.user.AppViewModel
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

internal external interface ContactUsPageProps : Props {
    var appViewModel: AppViewModel
    var onNavigateToDashboard: () -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

internal val ContactUsPage = FC<ContactUsPageProps> { props ->
    TopBar {
        title = "Contact Us"
        onSignOut = { props.appViewModel.signOut() }
        onNavigateToDashboard = props.onNavigateToDashboard
        onNavigateToPayment = props.onNavigateToPayment
        onNavigateToContactUs = props.onNavigateToContactUs
    }

    div {
        className = ClassName("contact-page-shell")
        div {
            className = ClassName("contact-page-content")
            ContactEmailIcon { }
            h2 { className = ClassName("contact-page-title"); +"Have questions or feedback?" }
            p {
                className = ClassName("contact-page-body")
                +"We'd love to hear from you. Tap the button below to send us an email."
            }
            a {
                className = ClassName("primary-button")
                href = "mailto:support@yogaaicoach.com"
                +"Contact Us"
            }
            p { className = ClassName("contact-email-address"); +"support@yogaaicoach.com" }
        }
    }
}
